import styled, { css } from '@app/styled';
import { color, modifier, radius } from '@app/theme';

export const Badge = styled.div<{ $small: boolean }>`
    position: absolute;
    top: -3px;
    right: -2px;
    background-color: ${color('custom.red.500')};
    font-size: 10px;
    color: ${color('text.inverse')};
    border-radius: ${radius('rounded')};
    width: 15px;
    height: 15px;
    line-height: 15px;
    text-align: center;

    ${modifier(
        '$small',
        css`
            font-size: 8px;
            width: 12px;
            height: 12px;
            line-height: 12px;
        `,
    )};
`;

export const withNavIconStyle = css`
    display: flex;
    appearance: none;
    border: none;
    justify-content: center;
    align-items: center;
    height: 30px;
    width: 30px;
    padding: 0;
    border-radius: ${radius('rounded')};
    color: ${color('background.switch.default')};
    position: relative;

    &:hover {
        color: ${color('background.action.primary.hover')};
    }

    ${modifier(
        '$small',
        css`
            height: 20px;
            width: 20px;
        `,
    )};

    & svg {
        pointer-events: none;
    }
`;

export type IconType = 'tasks' | 'contributors' | 'download' | 'more';
type NavItem = {
    $icon: IconType;
    $small: boolean;
};

export const NavLink = styled.a<NavItem>`
    ${withNavIconStyle};
`;

export const NavButton = styled.button<NavItem & { disabled: boolean }>`
    ${withNavIconStyle};
    ${modifier(
        'disabled',
        css`
            cursor: default;
            pointer-events: none; // Fixes issue with mouseLeave not firing after tooltip is shown
            color: ${color('background.action.secondary.default')};

            &:hover,
            &:focus {
                color: ${color('background.action.primary.hover')};
            }

            &:active {
                color: ${color('background.action.primary.pressed')};
            }

            &:active:hover {
                color: ${color('background.action.primary.pressed')};
            }
        `,
    )};
`;
